import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { requiredFiles } from '../../../useValidateQuestionnaire';
import { CovidReliefStateValues, updateKey } from './slice';

export const fields: IBaseField<keyof CovidReliefStateValues>[] = [
  {
    type: 'radio',
    name: 'receivedCovidPayment',
    label:
      'Did you receive US coronavirus stimulus payments in any year? (Economic Impact Payment)',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        predicate: (value) => value === 'yes',
        type: 'select',
        name: 'receivedCovidPaymentFirstOrSecond',
        label:
          'Did you receive the first stimulus, the second, or both stimulus payments?',
        subLabel: () => (
          <p>
            The first was up to $1,200 per adult plus $500 per child. The second
            was up to $600 each. Ignore the third stimulus payment of $1,400
            each.
          </p>
        ),
        tooltip: '',
        options: [
          {
            label: 'First stimulus check of $1200',
            value: 'First stimulus check of $1200',
          },
          {
            label: 'Second stimulus check of $600',
            value: 'Second stimulus check of $600',
          },
          {
            label: 'I received both stimulus checks',
            value: 'I received both stimulus checks',
          },
        ],
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            type: 'upload',
            name: 'firstGovStimulusCopy',
            label: 'Please Upload Notice 1444 (preferred)',
            subLabel: () => (
              <p>
                If you don't have this - it's ok. Please make sure to complete
                the amount below
              </p>
            ),
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            info: ['First government stimulus package'],
            predicate: (value) =>
              value === 'First stimulus check of $1200' ||
              value === 'I received both stimulus checks',
          },
          {
            type: 'currency',
            name: 'firstGovStimulusAmount',
            label:
              'Please provide the amount received from the first coronavirus stimulus payment',
            tooltip: '',
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'First stimulus check of $1200' ||
              value === 'I received both stimulus checks',
          },
          {
            type: 'upload',
            name: 'secondGovStimulusCopy',
            label: 'Please Upload Notice 1444 (preferred)',
            subLabel: () => (
              <p>
                If you don't have this - it's ok. Please make sure to complete
                the amount below
              </p>
            ),
            tooltip: '',
            info: ['Second government stimulus package'],
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'Second stimulus check of $600' ||
              value === 'I received both stimulus checks',
          },
          {
            type: 'currency',
            name: 'secondGovStimulusAmount',
            label:
              'Please provide the amount received from the first coronavirus stimulus payment',
            tooltip: '',
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'Second stimulus check of $600' ||
              value === 'I received both stimulus checks',
          },
        ],
      },
    ],
  },
  {
    type: 'radio',
    name: 'diagnosedWithCovid',
    label:
      'Were you or anyone in your household diagnosed with COVID-19 in {year}?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'radio',
    name: 'adverseFinancialImpact',
    label:
      'Did you or your spouse experience any adverse financial impact due to COVID-19',
    subLabel: () => <p>Lost job, reduced work schedule, etc.</p>,
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'radio',
    name: 'unableToWorkDueLackClildCare',
    label:
      'Were you unable to work due to lack of child care or school due to COVID-19?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'text',
        name: 'clildCarehowManyDays',
        label: 'How many days were you unable to work?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        placeholder: 'Enter',
      },
      {
        type: 'text',
        name: 'clildCareChildName',
        label: 'What is the name of the child?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        placeholder: 'Enter',
      },
      {
        type: 'text',
        name: 'clildCareSchoolName',
        label:
          'What is the name of the school, place of care, or child care provider that closed or become unavailable?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        placeholder: 'Enter',
      },
      {
        type: 'checkbox',
        name: 'clildCareConfirmNoOtherPerosns',
        label:
          'Please confirm there was no other suitable person available to care for your child?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'uOrSpouseTakeEarlyDistrubutions',
    label:
      'Did you or your spouse take any early distributions from retirement account(s) due to COVID-19?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'radio',
    name: 'unableToWorkDueToCovid',
    label:
      'From 4/1/Year to 12/31/Year, were you unable to work or telework because of COVID-19?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'radio',
        name: 'subjectToQuarentine',
        label:
          'Were you subject to a quarantine or isolation order related to COVID-19?',
        subLabel: () => <p>Refers to federal, state, or local</p>,
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            type: 'text',
            name: 'subjectToQuarentineDays',
            label: 'How many days were you unable to work?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
          {
            type: 'text',
            name: 'subjectToQuarentineGovEntity',
            label: 'Which government entity issued the order?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
        ],
      },
      {
        type: 'radio',
        name: 'advicedToQuarentine',
        label:
          'Were you advised by a health care provider to self-quarantine due to concerns related to COVID-19?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            type: 'text',
            name: 'advicedToQuarentineDays',
            label: 'How many days were you unable to work?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
          {
            type: 'text',
            name: 'advicedToQuarentineHelathProvider',
            label: 'What is the name of the health care provider?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
        ],
      },
      {
        type: 'radio',
        name: 'experiencedSymptoms',
        label:
          'Did you experience symptoms of COVID-19 and take time off to seek a medical diagnosis?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            type: 'text',
            name: 'experiencedSymptomsDays',
            label: 'How many days were you unable to work?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
        ],
      },
      {
        type: 'select',
        name: 'careForAnIndividual',
        label:
          'Did you care for an individual who was subject to a quarantine or isolation order related to COVID-19 or had been advised by a health care provider to self-quarantine due to concerns related to COVID-19?',
        subLabel: () => (
          <p>
            Quarantine or isolation order refers to federal, state, or local
          </p>
        ),
        options: [
          {
            label: 'Government Quarantine oredr',
            value: 'Government Quarantine oredr',
          },
          {
            label: 'Advised by health care provider to self quarantine',
            value: 'Advised by health care provider to self quarantine',
          },
          {
            label:
              'Both Government oredr & Advised by health care provider to self quarantine',
            value:
              'Both Government oredr & Advised by health care provider to self quarantine',
          },
          { label: 'No', value: 'no' },
        ],
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
        dependencies: [
          {
            type: 'text',
            name: 'careForAnIndividualHealthCareNameProvider',
            label: 'What is the name of the health care provider?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'Advised by health care provider to self quarantine' ||
              value ===
                'Both Government oredr & Advised by health care provider to self quarantine',
            placeholder: 'Enter',
          },
          {
            type: 'text',
            name: 'careForAnIndividualGovEntity',
            label: 'Which government entity issued the order?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'Government Quarantine oredr' ||
              value ===
                'Both Government oredr & Advised by health care provider to self quarantine',
            placeholder: 'Enter',
          },
          {
            type: 'text',
            name: 'careForAnIndividualDaysUnableToWork',
            label: 'How many days were you unable to work?',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) =>
              value === 'Government Quarantine oredr' ||
              value === 'Advised by health care provider to self quarantine' ||
              value ===
                'Both Government oredr & Advised by health care provider to self quarantine',
            placeholder: 'Enter',
          },
        ],
      },
    ],
  },
  {
    type: 'radio',
    name: 'receiveFamilyBenefits',
    label:
      'Did you or your spouse receive state, federal, and/or employer unemployment, paid sick leave, or emergency family leave benefits due to COVID-19?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
  {
    type: 'textarea',
    name: 'additionalNotes',
    label:
      'Please add any additional notes about COVID-19 impact on your financial situation',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
